/*

usha 09/29/2022  2698947782 Customization in custom window
ashraf 10/06/2022  2698947782 added comments to code, removed unusual code
ashraf 10/07/2022  2698947782 removed commented code
ashraf 10/15/2022  2698947782 Added custom windows code comments
ashraf 10/27/2022  2698947782 custom window UX changes
Sai Maheshwar 04/11/2022  2698947782 corrected component name

*/

import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import UDWTabs from './SubTabs';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function CustomWindowTabs({value}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 && (
          <UDWTabs/>
        )}
      </div>
    </div>
  );
}
